import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import specialSurfaceImage from "@/assets/special-surface.jpg";
import bathroomRef1 from "@/assets/bathroom-ref-1.jpg";
import floorImg from "@/assets/floor.jpg";
import interiorRef1 from "@/assets/interior-ref-1.jpg";

const clusters = [
  {
    title: "Innensanierung & Malerarbeiten",
    text: "Q4 Spachtelung, Tapezieren & Modernisierung – perfekte Untergründe für Ihren Wohntraum.",
    link: "/malerarbeiten-innenraum",
    cta: "Mehr zu Malerarbeiten",
    image: interiorRef1,
    alt: "Malerarbeiten und Spachteltechnik Herford"
  },
  {
    title: "Badsanierung & Fugenlos",
    text: "Mikrozement & fugenlose Wände – moderne Badgestaltung ohne Fliesen, hygienisch und pflegeleicht.",
    link: "/fugenlose-baeder-oberflaechen",
    cta: "Mehr zur Badsanierung",
    image: bathroomRef1,
    alt: "Fugenlose Badsanierung Herford"
  },
  {
    title: "Edle Oberflächen & Design",
    text: "Betonoptik, Metalloptik & Kalkspachtel – individuelle Unikate für anspruchsvolle Räume.",
    link: "/fugenlose-baeder-oberflaechen",
    cta: "Mehr zu Design-Oberflächen",
    image: specialSurfaceImage,
    alt: "Exklusive Wandgestaltung und Spachteltechnik Herford"
  },
  {
    title: "Bodenverlegung",
    text: "Designböden, Parkett & professionelle Untergrundvorbereitung für höchste Ansprüche.",
    link: "/fugenlose-baeder-oberflaechen",
    cta: "Mehr zu Bodensystemen",
    image: floorImg,
    alt: "Designböden und Bodenverlegung Herford"
  }
];

export const ServiceClusters = () => {
  return (
    <section id="leistungen" className="py-16 md:py-24 lg:py-32 bg-background">
      <div className="container mx-auto">
        <div className="max-w-3xl mb-10 md:mb-16">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-4 block">
            Weitere Leistungen
          </span>
          <h2 className="font-caslon text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-foreground">
            Unser Full-Service: Von der Fassade bis zum Designboden
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Neben der energetischen Sanierung bieten wir Ihnen das volle Programm für Ihr Zuhause.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {clusters.map((cluster, index) => (
            <Link
              key={index}
              to={cluster.link}
              className="group relative rounded-xl overflow-hidden bg-foreground min-h-[360px] flex flex-col justify-end"
            >
              <img 
                src={cluster.image} 
                alt={cluster.alt}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground via-foreground/50 to-transparent" />

              <div className="relative z-10 p-8">
                <h3 className="font-caslon text-2xl font-bold text-background mb-2">
                  {cluster.title}
                </h3>
                <p className="text-background/60 mb-4 leading-relaxed text-sm">
                  {cluster.text}
                </p>
                <span className="inline-flex items-center text-sm font-medium text-background/80 group-hover:text-background group-hover:translate-x-2 transition-all duration-300">
                  {cluster.cta}
                  <ArrowRight className="ml-2 h-4 w-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
